import React from "react";

const JoinCommunitySection = () => {
  return (
    <section
      id="join-now"
      className="py-16 bg-gradient-to-r from-rose-700 to-rose-900 text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-4">
              Join Our Community Today
            </h2>
            <p className="text-xl text-rose-100 mb-6">
              Become part of a global network of energy enthusiasts, share your
              knowledge, and help shape the future of sustainable energy
              communities.
            </p>

            <ul className="space-y-3 mb-8">
              {[
                "Connect with experts and enthusiasts worldwide",
                "Access exclusive resources and case studies",
                "Participate in discussions and knowledge sharing",
                "Stay updated on the latest trends and events",
              ].map((benefit, index) => (
                <li key={index} className="flex items-start">
                  <svg
                    className="h-6 w-6 text-rose-300 mr-2 flex-shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-wrap gap-4">
              <button className="px-8 py-3 bg-white text-rose-700 font-medium rounded-lg hover:bg-rose-50 transition-colors shadow-lg">
                Sign Up Now
              </button>
              <button className="px-8 py-3 bg-transparent border border-white text-white font-medium rounded-lg hover:bg-white/10 transition-colors">
                Learn More
              </button>
            </div>
          </div>

          <div className="md:w-1/2 bg-white/10 p-8 rounded-xl backdrop-blur-sm">
            <h3 className="text-2xl font-semibold mb-6">
              What Our Members Say
            </h3>

            <div className="space-y-6">
              <div className="bg-white/20 p-4 rounded-lg backdrop-blur-sm">
                <p className="italic mb-4">
                  "This forum has been an invaluable resource for our community
                  energy project. The knowledge sharing and support from other
                  members helped us overcome numerous challenges."
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-rose-200 rounded-full flex items-center justify-center text-rose-700 font-bold">
                    JD
                  </div>
                  <div className="ml-3">
                    <div className="font-medium">Jane Doe</div>
                    <div className="text-sm text-rose-200">
                      Community Energy Coordinator
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white/20 p-4 rounded-lg backdrop-blur-sm">
                <p className="italic mb-4">
                  "I've connected with professionals from across Europe and
                  gained insights that have been crucial for developing our
                  local energy sharing initiative."
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-rose-200 rounded-full flex items-center justify-center text-rose-700 font-bold">
                    MS
                  </div>
                  <div className="ml-3">
                    <div className="font-medium">Michael Smith</div>
                    <div className="text-sm text-rose-200">
                      Renewable Energy Consultant
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinCommunitySection;
